import React from 'react';
import { useHistory } from 'react-router-dom';
import { getBotTypeLabel, getBotStatusClass, getCompositionSummary, getBotPerformancePath } from './botUtils';

/**
 * props:
 * - bot
 * - onEditClick
 * - onStartClick
 * - onStopClick
 * - onDeleteClick
 */
function BotRow({
    bot,
    onEditClick,
    onStartClick,
    onStopClick,
    onDeleteClick,
}) {
    const history = useHistory();

    function handleEditClick(event) {
        if (bot.type === 'ALGO') {
            history.push(`/unified-setup?botId=${bot.sourceId}`);
            return;
        }
        if (bot.type === 'GRID') {
            history.push(`/grid?automationId=${bot.sourceId}`);
            return;
        }
        if (bot.type === 'SCHEDULED') {
            history.push(`/scheduled?automationId=${bot.sourceId}`);
            return;
        }
        onEditClick(event, bot);
    }

    return (
        <tr>
            <td>
                <span className={`bot-type-badge bot-type-badge--${(bot.type || 'unknown').toLowerCase()}`}>
                    {getBotTypeLabel(bot.type)}
                </span>
            </td>
            <td>{bot.symbol}</td>
            <td>{bot.name}</td>
            <td>
                <span className="text-muted small">{getCompositionSummary(bot)}</span>
            </td>
            <td>
                <span className={getBotStatusClass(bot)}>{bot.statusLabel}</span>
            </td>
            <td>
                <button
                    id={`performance${bot.sourceId}`}
                    type="button"
                    className="btn btn-info text-white bg-[#0ea5e9] hover:bg-[#0284c7] btn-xs ms-2"
                    title="View performance"
                    onClick={() => history.push(getBotPerformancePath(bot))}
                >
                    <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
                    </svg>
                </button>
                <button
                    id={`edit${bot.sourceId}`}
                    type="button"
                    className="btn btn-secondary text-[#1F2937] bg-[#f0bc74] hover:bg-[#f2c689] btn-xs ms-2"
                    title="Edit bot"
                    onClick={handleEditClick}
                >
                    <svg className="icon icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                </button>
                {bot.isActive ? (
                    <button
                        id={`stop${bot.sourceId}`}
                        type="button"
                        className="btn btn-danger bg-[#E11D48] text-white hover:bg-[#bf193d] btn-xs ms-2"
                        title="Stop bot"
                        onClick={onStopClick}
                    >
                        <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clipRule="evenodd" />
                        </svg>
                    </button>
                ) : null}
                {!bot.isActive ? (
                    <button
                        id={`start${bot.sourceId}`}
                        type="button"
                        className="btn btn-success text-[#1F2937] bg-[#10B981] hover:bg-[#34c494] btn-xs ms-2"
                        title="Start bot"
                        onClick={onStartClick}
                    >
                        <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                        </svg>
                    </button>
                ) : null}
                {!bot.isActive ? (
                    <button
                        id={`delete${bot.sourceId}`}
                        type="button"
                        className="btn btn-danger bg-[#E11D48] text-white hover:bg-[#bf193d] btn-xs ms-2"
                        title="Delete bot"
                        onClick={onDeleteClick}
                    >
                        <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                    </button>
                ) : null}
            </td>
        </tr>
    );
}

export default BotRow;